import fetch from 'isomorphic-fetch';
import { showFailure } from '../../common/toast';
import { browserHistory } from 'react-router';

const getDataHelper = async (apiEndPoint, data = {}) => {
  // Retrieve token from localStorage
  const { token = '' } = JSON.parse(localStorage.getItem('localstorageval')) || {};

  // Construct headers
  const headers = token ? { Authorization: token } : {};
  // Create query string manually
  const queryString = Object.entries(data)
    .filter(([, value]) => value) // Keep only non-empty values
    //encodeURIComponent ensures that special characters are properly formatted so they do not disrupt the structure of the URL or cause errors.
    .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
    .join('&');

  // Construct URL with parameters
  const urlWithParams = queryString ? `${apiEndPoint}?${queryString}` : apiEndPoint;

  // Make the fetch request and return the JSON response
  let response = {};
  response = await fetch(urlWithParams, { method: 'GET', headers });
  const responseData = await response.json(); // Parse the response once

  if (responseData && !responseData.success && responseData.message === 'token is invalid') {
    localStorage.removeItem('localstorageval');
    showFailure('Token has been expired');
    browserHistory.push('/');
  }

  // Return the parsed response data instead of calling `response.json()` again
  return responseData;
};

exports.callAPI = getDataHelper;



// WEBPACK FOOTER //
// ./src/views/RestAPI/getDataService.js